import React from 'react';
import { connect, useSelector } from 'react-redux';
import { compose } from 'recompose';
import useRouter from 'use-react-router';
import { StoreState } from '@mm/state/store-interfaces';
import { MarketplaceSettings } from './MarketplaceSettings/MarketplaceSettings';
import { NotificationSettings } from './NotificationSettings/NotificationSettings';
import { ResponseSettings } from './ResponseSettings/ResponseSettings';
import { BotBuilderRoutes } from '../../../../../../routes/bot-builder-routes';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import './SystemMessagesSettingsSection.pcss';
import { Alert } from '@mm/components';

type OuterProps = {};

type InnerProps = ReturnType<typeof mapStateToProps>;

type Props = OuterProps & InnerProps;

const mapStateToProps = (state: StoreState) => ({
  chatbot: state.chatbot.activeChatbot,
});

const SystemMessagesSettingsSection = (props: Props) => {
  const { chatbot } = props;
  const { history } = useRouter();
  const chatbotId = useSelector(activeChatbotIdSelector);
  if (!chatbot) {
    return null;
  }

  return (
    <div className="system-messages-settings-section">
      <Alert type="info" showInfoIcon showCloseIcon={false}>
        Looking for Quick Question Validation & Subscription Settings? We moved
        it to{' '}
        <span
          className="system-messages-settings-section__link"
          onClick={() =>
            history.push(
              BotBuilderRoutes.automationRules.getLink({
                chatbotId,
                kind: 'system_messages',
              }),
            )
          }
        >
          Automation Rules.
        </span>
      </Alert>
      <ResponseSettings />
      <NotificationSettings />
      <MarketplaceSettings
        className="bot-publishing-pane__list-item"
        chatbot={chatbot}
      />
    </div>
  );
};

const enhance = compose<InnerProps, OuterProps>(connect(mapStateToProps));

export default enhance(SystemMessagesSettingsSection);
